<template>
  <div >
    <v-row>
      <v-col cols="6" >
        <div class="pa-4">
    <v-row>
      <v-col cols="4">
        <div class="preview-image-wrap">
          <img
            :src="require('@/assets/bestellung/dreifachaufsteller.jpg')"
            class="text-white align-end"
            height="120"
          />
          <span class="preview-number">{{ togoNumber }}</span>
        </div>
      </v-col>
      <v-col cols="8">
        <h3>WaizmannTabelle | Togo</h3>
        <div class="mb-4">
          Die meist angefragte WaizmannTabelle für Zahnärzte.
        </div>
     
      </v-col>
    </v-row>
    <v-btn color="primary" to="/waizmanntabellen_bestellen" width="100%">kostenlos anfordern</v-btn>
  </div>
  </v-col>
  <v-col cols="6">
    <div class="pa-4">
    <v-row>
      <v-col cols="4">
        <div class="preview-image-wrap">
          <img
            :src="require('@/assets/bestellung/auftstellerPzr.jpg')"
            class="text-white align-end"
            height="120"
          />
          <span class="preview-number">{{ pzrNumber }}</span>
        </div>
      </v-col>
      <v-col cols="8">
        <h3>WaizmannTabelle | PZR</h3>
        <div class="mb-4">
          Die WaizmannTabelle für Ihren Prophylaxe-Bereich.
        </div>
     
      </v-col>
    </v-row>
    <v-btn color="pink" to="/waizmanntabellen_bestellen" width="100%">kostenlos anfordern</v-btn>
  </div>
  </v-col>
</v-row>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useBaseStore } from "@/stores/baseStore";

const baseStore = useBaseStore();
const { waizmannTableTiles } = storeToRefs(baseStore);

const togoNumber = computed(() => {
  const tile = waizmannTableTiles.value.find((item) =>
    String(item.subtitle || "").toLowerCase().includes("togo")
  );
  return tile?.number || "No. 32";
});

const pzrNumber = computed(() => {
  const tile = waizmannTableTiles.value.find((item) =>
    String(item.subtitle || "").toLowerCase().includes("pzr")
  );
  return tile?.number || "No. 4";
});
</script>

<style scoped>
.preview-image-wrap {
  position: relative;
  display: inline-block;
}

.preview-number {
  position: absolute;
  top: 6px;
  left: 6px;
  background: rgba(16, 42, 67, 0.82);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  padding: 6px 8px;
  border-radius: 6px;
  letter-spacing: 0.2px;
}
</style>
